module.exports = __webpack_public_path__ + "assets/htu-9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/HTU-modal/htu-9.jpg
// module id = 1196
// module chunks = 7